import styled from '@emotion/styled';

const PublishedByWrapper = styled.div({
  overflow: 'hidden',
  width: '100%'
});

export default PublishedByWrapper;
